import { render, staticRenderFns } from "./getDriverwalletCSV.vue?vue&type=template&id=598839bf&scoped=true&"
import script from "./getDriverwalletCSV.vue?vue&type=script&lang=js&"
export * from "./getDriverwalletCSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598839bf",
  null
  
)

export default component.exports